import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
export const PriceChipLabel = ({ itemPrice, itemSalePrice, textRef }) => {
    const theme = useTheme();
    return (_jsxs(Stack, Object.assign({ spacing: 1, direction: "row" }, { children: [_jsx(Typography, Object.assign({ variant: "body3", ref: textRef, style: {
                    textDecorationLine: itemSalePrice ? "line-through" : undefined,
                    textDecorationColor: theme.palette.error.main,
                    fontSize: itemSalePrice ? ".8rem" : theme.typography.body3.fontSize,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "inherit",
                } }, { children: itemPrice })), itemSalePrice && (_jsx(Typography, Object.assign({ variant: "body3", style: {
                    color: theme.palette.success.main,
                    fontSize: theme.typography.body3.fontSize,
                } }, { children: itemSalePrice })))] })));
};
